import * as remoteAction from "../remoteAction";

export type LoyaltyOptInActionSuccess = remoteAction.MerchantRemoteResponse<
  "LOYALTY_OPTIN_SUCCESS",
  any
>;
export type LoyaltyOptInActionFailure = remoteAction.MerchantRemoteResponse<
  "LOYALTY_OPTIN_FAILURE",
  any
>;
export type LoyaltyOptInActionRequest = remoteAction.MerchantRemoteResponse<
  "LOYALTY_OPTIN_REQUEST",
  any
>;

export interface LoyaltyOptInAction extends remoteAction.PostRemoteRequest {
  types: {
    request: "LOYALTY_OPTIN_REQUEST";
    success: "LOYALTY_OPTIN_SUCCESS";
    failure: "LOYALTY_OPTIN_FAILURE";
  };
}

export interface LoyaltyOptInParams {
  email: string;
  optin: boolean;
}

export const loyaltyOptIn = ({
  email,
  optin = true,
}: LoyaltyOptInParams): LoyaltyOptInAction => ({
  type: "MERCHANT_REMOTE_REQUEST",
  types: {
    request: "LOYALTY_OPTIN_REQUEST",
    failure: "LOYALTY_OPTIN_FAILURE",
    success: "LOYALTY_OPTIN_SUCCESS",
  },
  method: "POST",
  https: true,
  data: {
    email,
    optin,
  },
  url: `/share/loyalty/subscribe`,
});
